export class PaginationData {
  constructor(pages, currentPage, elements, totalElements, filters) {
    this.pages = pages || 0;
    this.currentPage = currentPage || 0;
    this.elements = elements || 0;
    this.totalElements = totalElements || 0;
    this.filters = filters || {};
  }
}

export class LastSession {
  constructor(
    baseStationName,
    state,
    lastUpdate,
    lastConnectionStart,
    lastConnectionStop
  ) {
    this.baseStationName = baseStationName || "string";
    this.state = state || "string";
    this.lastUpdate = lastUpdate || 0;
    this.lastConnectionStart = lastConnectionStart || 0;
    this.lastConnectionStop = lastConnectionStop || 0;
  }
}
export class RobotsResponse {
  constructor(response) {
    const { pages, currentPage, elements, totalElements, filters, data } =
      response;
    this.pagination = new PaginationData(
      pages,
      currentPage,
      elements,
      totalElements,
      filters ? filters : {}
    );
    this.data =
    data && data.length > 0
      ? data.map((item) => ({
      imei: item.imei || "string",
      lastSession: item.lastSession.state?new LastSession(
        item.lastSession.baseStationName || "string",
        item.lastSession.state || "string",
        item.lastSession.lastUpdate || 0,
        item.lastSession.lastConnectionStart || 0,
        item.lastSession.lastConnectionStop || 0
      ):null,
    })): [];
  }
}
// Example usage:
const responseJSON = {
  pages: 0,
  currentPage: 0,
  elements: 0,
  totalElements: 0,
  filters: {
    additionalProp1: "string",
    additionalProp2: "string",
    additionalProp3: "string",
  },
  data: [
    {
      imei: "string1",
      lastSession: {
        baseStationName: "station1",
        state: "state1",
        lastUpdate: 123456,
        lastConnectionStart: 7890,
        lastConnectionStop: 9876,
      },
    },
    {
      imei: "string2",
      lastSession: {
        baseStationName: "station2",
        state: "state2",
        lastUpdate: 654321,
        lastConnectionStart: 2345,
        lastConnectionStop: 5432,
      },
    },
  ],
};

const robotsResponse = new RobotsResponse(responseJSON);

console.log(robotsResponse);

// export class RobotsResponse {
//         constructor(response) {
//             const { pages, currentPage, elements, totalElements, filters, data } = response;
//             const imei = data && data.length > 0 ? data[0].imei : undefined;
//             const lastSession = data && data.length > 0 ? data[0].lastSession : {};

//             this.pagination = new PaginationData(pages, currentPage, elements, totalElements, filters ? filters : {}, [
//                 {
//                     imei: imei,
//                     lastSession: new LastSession(
//                         lastSession.baseStationName,
//                         lastSession.state,
//                         lastSession.lastUpdate,
//                         lastSession.lastConnectionStart,
//                         lastSession.lastConnectionStop
//                     )
//                 }
//             ]);
//             this.data = this.pagination.data;
//         }

//     constructor(pages, currentPage, elements, totalElements, filters, imei, lastSession) {
//         this.pagination = new PaginationData(pages, currentPage, elements, totalElements, filters, [
//             {
//                 imei: imei || "string",
//                 lastSession: new LastSession(
//                     lastSession.baseStationName,
//                     lastSession.state,
//                     lastSession.lastUpdate,
//                     lastSession.lastConnectionStart,
//                     lastSession.lastConnectionStop
//                 )
//             }
//         ]);
//         this.data = this.pagination.data;
//     }
// }

// // Example usage:
// const responseJSON = {
//     "pages": 0,
//     "currentPage": 0,
//     "elements": 0,
//     "totalElements": 0,
//     "filters": {
//         "additionalProp1": "string",
//         "additionalProp2": "string",
//         "additionalProp3": "string"
//     },
//     "data": [
//         {
//             "imei": "string",
//             "lastSession": {
//                 "baseStationName": "string",
//                 "state": "string",
//                 "lastUpdate": 0,
//                 "lastConnectionStart": 0,
//                 "lastConnectionStop": 0
//             }
//         }
//     ]
// };

// const RobotsResponse = new RobotsResponse(
//     responseJSON.pages,
//     responseJSON.currentPage,
//     responseJSON.elements,
//     responseJSON.totalElements,
//     responseJSON.filters ? responseJSON.filters : {},
//     responseJSON.data && responseJSON.data.length > 0 ? responseJSON.data[0].imei : undefined,
//     responseJSON.data && responseJSON.data.length > 0 ? responseJSON.data[0].lastSession : {}
// );

// console.log(RobotsResponse);

export class SessionData {
  constructor({
    imei,
    baseStationName,
    sessionStart,
    sessionStop,
    reasonSessionTerminated,
    hardwareModel,
    totalBytes,
    ntripVersion,
    baseStationSession,
  }) {
    this.imei = imei || "";
    this.baseStationName = baseStationName || "";
    this.sessionStart = sessionStart || 0;
    this.sessionStop = sessionStop || 0;
    this.reasonSessionTerminated = reasonSessionTerminated || "";
    this.hardwareModel = hardwareModel || "";
    this.totalBytes = totalBytes || 0;
    this.ntripVersion = ntripVersion || "";
    this.baseStationSession = baseStationSession || {
      lastConnectionStart: 0,
      lastConnectionStop: 0,
    };
  }
}

export class RobotSessionResponse {
  constructor({ pages, currentPage, elements, totalElements, filters, data }) {
    this.pagination = new PaginationData(
      pages,
      currentPage,
      elements,
      totalElements,
      filters || {}
    );
    this.data =
      data && data.length > 0
        ? data.map((session) => new SessionData(session))
        : [];
  }
}

// Example usage:
const response2JSON = {
  pages: 0,
  currentPage: 0,
  elements: 0,
  totalElements: 0,
  filters: {
    additionalProp1: "string",
    additionalProp2: "string",
    additionalProp3: "string",
  },
  data: [
    {
      imei: "string1",
      baseStationName: "station1",
      sessionStart: 0,
      sessionStop: 0,
      reasonSessionTerminated: "reason1",
      hardwareModel: "hardware1",
      totalBytes: 100,
      ntripVersion: "v1",
      baseStationSession: {
        lastConnectionStart: 0,
        lastConnectionStop: 0,
      },
    },
    {
      imei: "string2",
      baseStationName: "station2",
      sessionStart: 0,
      sessionStop: 0,
      reasonSessionTerminated: "reason2",
      hardwareModel: "hardware2",
      totalBytes: 200,
      ntripVersion: "v2",
      baseStationSession: {
        lastConnectionStart: 0,
        lastConnectionStop: 0,
      },
    },
  ],
};

const robotSessionResponse = new RobotSessionResponse(response2JSON);

console.log(robotSessionResponse);
